import {apiLocker, Form, formsStore} from '../../../stores/Form';
import {isMessageShown} from '../../Messages/actions';

export const isNavigationLocked = (form: Form) => {
    return (
        formsStore.currentScreen?.isNavigationBlocked ||
        isMessageShown ||
        formsStore.currentScreen?.activeLevel !== form?.level ||
        !!apiLocker.getDataBySession(form?.session)?.locked
    );
};
